<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Employment Allowance</h1>
    <p>Employment Allowance allows eligible employers to reduce their annual National Insurance liability.</p>
    <p>To assess whether your company is elibile for Employment Allowance view <a href="https://www.gov.uk/claim-employment-allowance/eligibility" target="_blank">gov.uk</a></p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="custom-check">
             <input type="checkbox" v-model="formData.hasEmploymentAllowance">My company is eligible for Employment Allowance and I wish to claim it
            <span class="checkmark"></span>
            </label>
            <div v-if="formData.hasEmploymentAllowance && formData.payrollType === 'existingscheme'">
              <br/>
              <label>Employment Allowance claimed during this tax year</label>
              <div class="grid-x grid-margin-x">
                <div class="cell small-3">
                      <input 
                      type="text" 
                      id="employmentAllowanceAlreadyClaimed" 
                      name="employmentAllowanceAlreadyClaimed" 
                      placeholder="0.00" 
                      v-model="formData.employmentAllowanceAlreadyClaimed" 
                      required 
                      inputmode="numeric"
                    >
                </div>
              </div>
            </div>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref(null)

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>